<template>
  <div>
    <!-- horizontal scrollable menu -->
    <nav class="nav ml-3 mr-3">
      <div class="col-12 card-header mt-3 mt-lg-4 mb-3">
        <div class="row no-gutters">
          <ul class="nav nav-tabs font12-boldcolor d-flex flex-nowrap mobviewItems">
            <li class="nav-item ml-lg-1 mr-lg-1 mr-md-2 mouseoveraction">
              <a :class="{'fontsize12 blue proximanova-semibold border-tab':activeClass == 'about_us_tab'}" id="about_us_tab"
                class="proximanova-semibold text-nowrap"
                @click="toggleActiveClass('about_us_tab')"                    
              >About Us</a>
            </li>
            <div class="verticaline mt-2"> | </div>
            <li class="nav-item ml-lg-1 mr-lg-1 mr-md-2 mouseoveraction">
              <a :class="{'fontsize12 blue proximanova-semibold border-tab':activeClass == 'people_tab'}" id="people_tab"          
                class="proximanova-semibold text-nowrap"
                @click="toggleActiveClass('people_tab')"                
              >People</a>
            </li>
            <div class="verticaline mt-2 "> | </div>
            <li class="nav-item ml-lg-1 mr-lg-1 mr-md-2 mouseoveraction">
              <a :class="{'fontsize12 blue proximanova-semibold border-tab':activeClass == 'culture_tab'}" id="culture_tab"
                class="proximanova-semibold text-nowrap"
                @click="toggleActiveClass('culture_tab')"                          
              >Culture</a>
            </li>
            <div class="verticaline mt-1"> | </div>
            <li class="nav-item ml-lg-1 mr-lg-1 mr-md-2 mouseoveraction">
              <a :class="{'fontsize12 blue proximanova-semibold border-tab':activeClass == 'product_tab'}" id="product_tab"
                class="proximanova-semibold text-nowrap"
                @click="toggleActiveClass('product_tab')"                       
              >Product</a>
            </li>
            <div class="verticaline mt-1"> | </div>
            <li class="nav-item ml-lg-1 mr-lg-1 mr-md-2 mouseoveraction">
              <a  :class="{'fontsize12 blue proximanova-semibold border-tab':activeClass == 'services_tab'}" id="services_tab"
                class="proximanova-semibold text-nowrap"
                @click="toggleActiveClass('services_tab')"                       
              >Servicess</a>
            </li>
            <div class="verticaline mt-1"> | </div>
            <li class="nav-item ml-lg-1 mr-lg-1 mr-md-2 mouseoveraction">
              <a :class="{'fontsize12 blue proximanova-semibold border-tab':activeClass == 'post_tab'}" id="post_tab"
                class="proximanova-semibold text-nowrap"
                @click="toggleActiveClass('post_tab')"                       
              >Post</a>
            </li>
            <div class="verticaline mt-1"> | </div>
            <li class="nav-item ml-lg-1 mr-lg-1 mr-md-2 mouseoveraction">
              <a :class="{'fontsize12 blue proximanova-semibold border-tab':activeClass == 'jobs_tab'}" id="jobs_tab"
                class="proximanova-semibold text-nowrap"
                @click="toggleActiveClass('jobs_tab')"                       
              >Job</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- tab content -->
    <peopleTab v-if="showPeople"></peopleTab>
    <about-us-tab v-if="showAboutUs"></about-us-tab>
    <productTab v-if="showProductTab"></productTab>
    <service-tab v-if="showService"></service-tab>
    <div class="row no-gutters" v-if="showCulture">
      <p class="fontsize12 black pointer ml-4" :class="{'stylebold':activeCulturetabClass == 'culture_videos_tab'}" id="culture_videos_tab" @click="toggleActiveCultureClass('culture_videos_tab')">Culture videos</p> 
      <p class="fontsize12 black pointer ml-4" :class="{'stylebold':activeCulturetabClass == 'benifits_tab'}" id="benifits_tab" @click="toggleActiveCultureClass('benifits_tab')">Benifits</p>
      <div class="col-lg-12">
        <culture-tab v-if="cultureVideosTab"></culture-tab>
        <benefits-tab v-if="benifitsTab"></benefits-tab>
      </div>
    </div>
    <post-tab v-if="showPostTab"></post-tab>
    <job-tab v-if="showJobTab"></job-tab>
  </div>
</template>
<script>

import peopleTab from './PeopleTab.vue'
import aboutUsTab from './AboutUsTab.vue'
import cultureTab from './CultureTab.vue'
import benefitsTab from './BenefitsTab.vue'
import postTab from './PostTab.vue'
import jobTab from './JobTab.vue'
import productTab from './ProductVideoTab.vue'
import serviceTab from './ServiceVideo.vue'
export default {
    components:{
        peopleTab,
        aboutUsTab,
        cultureTab,
        benefitsTab,
        postTab,
        jobTab,
        productTab,
        serviceTab
    },
    data(){
      return{
        activeClass: "about_us_tab",
        showPeople: false,
        showAboutUs : true,
        showCulture : false,
        cultureVideosTab : false,
        benifitsTab : false,
        showPostTab : false,
        showJobTab : false,
        showProductTab: false,
        showService: false,
        //tabs section
        activeCulturetabClass : 'culture_videos_tab'
      }
    },
    methods : {
      // set active for horizontal menu
      toggleActiveClass(elementId) {
        console.log(elementId)
        this.activeClass = elementId;
        if (elementId === "people_tab") {
          this.showPeople = true;
          this.showAboutUs = false;
          this.showCulture = false;
          this.cultureVideosTab = false;
          this.benifitsTab = false;
          this.showPostTab = false;
          this.showJobTab = false;
          this.showProductTab = false;
          this.showService = false
          this.activeCulturetabClass = 'culture_videos_tab'
        }else if(elementId === 'about_us_tab'){
          this.showAboutUs = true
          this.showPeople = false;
          this.showCulture = false;
          this.cultureVideosTab = false;
          this.benifitsTab = false;
          this.showPostTab = false;
          this.showJobTab = false;
          this.showProductTab = false;
          this.showService = false;
          this.activeCulturetabClass = 'culture_videos_tab'
        }else if(elementId === 'culture_tab'){
          this.showAboutUs = false
          this.showPeople = false;
          this.showCulture = true;
          this.cultureVideosTab = true;
          this.benifitsTab = false;
          this.showPostTab = false;
          this.showJobTab = false;
          this.showProductTab = false;
          this.showService = false;
        }else if(elementId === 'post_tab'){
          this.showAboutUs = false
          this.showPeople = false;
          this.showCulture = false;
          this.cultureVideosTab = false;
          this.benifitsTab = false;
          this.showPostTab = true;
          this.showJobTab = false;
          this.showProductTab = false;
          this.showService = false;
          this.activeCulturetabClass = 'culture_videos_tab'
        }else if(elementId === 'jobs_tab'){
          this.showAboutUs = false
          this.showPeople = false;
          this.showCulture = false;
          this.cultureVideosTab = false;
          this.benifitsTab = false;
          this.showPostTab = false;
          this.showJobTab = true;
          this.showProductTab = false;
          this.showService = false;
          this.activeCulturetabClass = 'culture_videos_tab'
        }else if(elementId === 'product_tab'){
          this.showAboutUs = false
          this.showPeople = false;
          this.showCulture = false;
          this.cultureVideosTab = false;
          this.benifitsTab = false;
          this.showPostTab = false;
          this.showJobTab = false;
          this.showProductTab = true;
          this.showService = false;
          this.activeCulturetabClass = 'culture_videos_tab'
        }else if(elementId === 'services_tab'){
          this.showAboutUs = false
          this.showPeople = false;
          this.showCulture = false;
          this.cultureVideosTab = false;
          this.benifitsTab = false;
          this.showPostTab = false;
          this.showJobTab = false;
          this.showProductTab = false;
          this.showService = true;
          this.activeCulturetabClass = 'culture_videos_tab'
        }
      },
      //set active for culture sub sections
      toggleActiveCultureClass(elementId) {
        this.activeCulturetabClass = elementId;
        if(elementId === 'culture_videos_tab'){
          this.cultureVideosTab = true;
          this.benifitsTab = false;
        }else if(elementId === 'benifits_tab'){
          this.cultureVideosTab = false;
          this.benifitsTab = true;
        }
      },
    }
}
</script>
<style scoped>
.nav-tabs {
  border-bottom: none !important;
}
.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.card-header {
  border-radius: 8px !important;
}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
.mobviewItems {
	overflow-x: auto;
}
.list-text-color {
  color: #0078FF ;
  font-family: "Proxima Nova";
  font-weight: bold;
  letter-spacing: 0;
}
nav ul li a {
  padding: 0.5rem 0.9rem;
}
</style>